import type { ReactElement } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { postTypeIconLabel, type PostTypeIconInput } from "./post-type-icon";

/** Attach hover/focus help to the existing badge without changing its layout. */
export function PostTypeTooltip({
  post,
  children,
}: {
  post: PostTypeIconInput;
  children: ReactElement;
}) {
  const label = postTypeIconLabel(post);
  return (
    <Tooltip>
      <TooltipTrigger
        asChild
        tabIndex={0}
        role="img"
        aria-label={label}
        className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.stopPropagation();
          }
        }}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
